
    var riot = require('riot')
    //src: starling/src/tags/menu/buttons/menu-button-add-comment.html
riot.tag2('menu-button-add-comment',
  '<svg class="bulk-actions-menu-item_icon"> <use xlink:href="#comment-icon"></use> </svg>',
  '',
  'class="bulk-actions-menu-item" data-tip="Add a comment" onclick="{startComment}"', function(opts) {
'use strict';

var _this = this;

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _commentsUi = require('lib/comments-ui');

var _regionUi = require('lib/region-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;

//this feels small enough to not move to library code -- it's just calling another function anyway

this.startComment = function () {
  canvas.hidePopups();
  _this.parent.update();

  var nodeIds = _this.parent.getSelectedNodeIds();
  if (nodeIds && nodeIds.length === 1) {
    _commentsUi.commentsUI.startNodeComment(nodeIds[0]);
  } else {
    var _getContentExtents = _this.getContentExtents(),
        et = _getContentExtents[0],
        el = _getContentExtents[1],
        eb = _getContentExtents[2],
        er = _getContentExtents[3];

    var position = {
      x: el,
      y: et - 25
    };
    canvas.panZoomTo([et - 25, el, et, el + 25], 1, { animate: true });
    _commentsUi.commentsUI.startCanvasComment({ position: position });
  }

  _eventTracking2.default.track({
    category: 'Toolbar',
    action: 'Comment',
    label: 'New Comment'
  });
};

this.getContentExtents = function () {
  var nodes = canvas.getSelectedNodes();
  var links = canvas.getSelectedLinks();
  var regions = _regionUi.regionUI.getSelectedRegions();

  var _canvas$getContentExt = canvas.getContentExtents({ nodes: nodes, links: links, regions: regions }),
      et = _canvas$getContentExt[0],
      el = _canvas$getContentExt[1],
      eb = _canvas$getContentExt[2],
      er = _canvas$getContentExt[3];

  return [et, el, eb, er];
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-button-add-comment')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/buttons/menu-button-add-comment.html
// module id = 740
// module chunks = 0